import React from 'react';
import Navbar from '../components/Navbar';
import Home from '../components/pages/Home';
import Intro from '../components/pages/Intro';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Services from '../components/pages/Services';
import Products from '../components/pages/Products';
import SignUp from '../components/pages/SignUp';
import TermsConditions from '../components/pages/TermsConditions';
import PrivacyPolicy from '../components/pages/PrivacyPolicy';
import Portfolio from '../components/pages/Portfolio';



function MobileRoutes() {
    return (
      <>
        <Router>
          <Navbar />
          <Routes>
            <Route path='/' element={<Intro/>} />
            <Route path='/home' element={<Home/>} />
            <Route path='/services' element={<Services/>} />
            <Route path='/products' element={<Products/>} />
            <Route path='/portfolio' element={<Portfolio/>} />
            <Route path='/sign-up' element={<SignUp/>} />
            <Route path='/terms-conditions' element={<TermsConditions/>} />
            <Route path='/privacy-policy' element={<PrivacyPolicy/>} />
  
          </Routes>
        </Router>
      </>
    );
  }
  
  export default MobileRoutes;
  